<div class="panel space-y-8">
  <div class="flex flex-col">
    <ng-container *ngFor="let type of typeList; index as i">
      <app-picklist-option [type]="type" [title]="titleList[i]" [accordion]="accordion" [orderNumber]="i" (updateActiveAccordion)="updateAccordion($event)"></app-picklist-option>
    </ng-container>
  </div>
</div>
